// @flow strict

import { type PropsWithChildren } from '@mondough/public-web-components'
import '@reach/dialog/styles.css'
import React, { useState } from 'react'
import toReact from 'react-html-parser'
import PaidSectionWrapper from '../../PaidSectionWrapper'
import styles from './PlusInsurance.module.scss'
import ModalWrapper from '../../ModalWrapper'

type Column = {|
  img?: string,
  title?: string,
  subtitle?: string,
  description?: string,
  modalPrompt?: string,
  modalHeadline?: string,
  modalCopyInHTML?: string,
|}

type Props = {
  columns?: Column[],
}

const PlusInsurance = ({ children, columns }: PropsWithChildren<Props>) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [currentModalIndex, setCurrentModalIndex] = useState()
  const handleOnClick = (evt, index) => {
    setCurrentModalIndex(index)
    setIsModalOpen(true)
  }

  if (
    columns == null ||
    columns.some(col => col == null || col.img == null || col.title == null)
  )
    return null

  return (
    <PaidSectionWrapper contentClassName={styles.content}>
      {children}
      <div className={styles.columnWrapper}>
        {columns &&
          columns.map((col, i) => {
            return (
              <div key={col.title} className={styles.column}>
                <img src={col.img} alt="" className={styles.img} />
                {col.title && (
                  <>
                    <h3 className={styles.title}>{col.title}</h3>
                    <small className={styles.subtitle}>
                      {col.subtitle || ''}
                    </small>
                    <p className={styles.description}>
                      {col.description || ''}
                    </p>
                    <button
                      className={styles.modalPrompt}
                      onClick={e => handleOnClick(e, i)}
                    >
                      {col.modalPrompt || 'Click Here'}
                    </button>
                  </>
                )}

                <ModalWrapper
                  isOpen={isModalOpen && currentModalIndex === i}
                  onDismiss={() => setIsModalOpen(false)}
                  ariaLabelledby={`modalHeader${i}`}
                >
                  <h1 id={`modalHeader${i}`} className={styles.modalTitle}>
                    {col.title}
                  </h1>
                  <small className={styles.modalSubitle}>{col.subtitle}</small>
                  <p className={styles.modalHeadline}>{col.modalHeadline}</p>
                  <hr className={styles.modalHr} />
                  <div className={styles.modalCopy}>
                    {toReact(col.modalCopyInHTML)}
                  </div>
                  <div className={styles.fadeout} />
                </ModalWrapper>
              </div>
            )
          })}
      </div>
    </PaidSectionWrapper>
  )
}

export default PlusInsurance
